import React from 'react';
import { Button } from '../ui/button';
import { PerformanceItem } from '../../lib/types';
import { formatCurrency, formatNumber } from '../../lib/export';

interface PerformanceTableProps {
  title: string;
  data: PerformanceItem[];
  viewType: 'revenue' | 'units';
  onToggleView: () => void;
  onSeeAll: () => void;
  className?: string;
}

export function PerformanceTable({ 
  title, 
  data, 
  viewType, 
  onToggleView, 
  onSeeAll, 
  className = '' 
}: PerformanceTableProps) {
  const displayData = data.slice(0, 10);

  const formatValue = (item: PerformanceItem) => {
    return viewType === 'revenue' ? formatCurrency(item.totalRevenue) : formatNumber(item.totalUnits);
  };

  return (
    <div className={`bg-white p-6 rounded-lg shadow ${className}`}>
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={onToggleView}>
            Toggle {viewType === 'revenue' ? 'Units' : 'Revenue'}
          </Button>
          <Button variant="outline" size="sm" onClick={onSeeAll}>
            See All
          </Button>
        </div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-medium text-gray-900">Rank</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Name</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">
                Total {viewType === 'revenue' ? 'Revenue' : 'Units'}
              </th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((item, index) => (
              <tr key={item.id} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-gray-600">#{index + 1}</td>
                <td className="py-3 px-4 text-sm font-medium text-gray-900">{item.name}</td>
                <td className="py-3 px-4 text-sm text-right font-medium text-gray-900">
                  {formatValue(item)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
